import { render } from "./FeatureCards.vue?vue&type=template&id=75342c15&scoped=true"
import script from "./FeatureCards.vue?vue&type=script&lang=js"
export * from "./FeatureCards.vue?vue&type=script&lang=js"

import "./FeatureCards.vue?vue&type=style&index=0&id=75342c15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75342c15"]])

export default __exports__